module.exports = __webpack_public_path__ + "img/piano_down_code.5da6511d.png";